import React from 'react';
import { Button, Grid, Image } from 'shared';
import { Text } from '@chakra-ui/react';
import { LuMap } from 'react-icons/lu';
import { Helmet } from 'react-helmet-async';
import { useReviewPageState } from '../model';

export const ReviewPage = () => {
    const { logoImage, yandexMapReviewLink } = useReviewPageState();

    return (
        <Grid height="100vh" width="100vw" position="relative">
            <Helmet>
                <title>Оценка работы Corso Catering</title>
                <meta name="description" content="Оценка работы Corso Catering" />
                <meta property="og:title" content="Оценка работы Corso Catering" />
            </Helmet>
            <Grid width="100vw" position="relative" zIndex={2} backdropFilter="blur(10px)">
                <Grid
                    margin="auto"
                    width={{
                        base: '80vw',
                        lg: '30vw',
                    }}
                    padding="2rem"
                >
                    <Grid gap="2rem">
                        <Grid margin="0 auto" background="#ffffff" pos="relative" width="70%">
                            <Image src={logoImage?.url} width="100%" />
                        </Grid>
                        <Text textAlign="center" fontSize="1.5rem">
                            Поделитесь своим впечатлением о нашей работе!
                            <br />
                            Это очень важно для нас!
                        </Text>
                        <Button size="2xl" fontSize="1.5rem" background="#ffffff" color="#000000" border="1px solid #000000" onClick={() => { window.location.href = yandexMapReviewLink || ''; }}>
                            <LuMap />
                            Оставить отзыв на Яндекс.Картах
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
